import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { SITE_STATUS } from './url-constants';

type SiteStatusEndpointSpecification = ApiEndpointSpecification;
export const SiteStatusEndpointSpecification: SiteStatusEndpointSpecification = {
    url: SITE_STATUS,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'SiteStatusRequestParams',
    requestBodySchemaName: 'SiteStatusRequestBody',
    okResponseSchemaName: 'SiteStatusOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:3,
};

export const invokeSiteStatus = Helpers.makeApiRequestFn<
    Types.SiteStatusRequestParams,
    Types.SiteStatusRequestBody,
    Types.SiteStatusOkResponse
>(SiteStatusEndpointSpecification);
